import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActionCard = ({ title, description, icon, action, route, color = 'primary' }) => {
  const navigate = useNavigate();

  const colorClasses = {
    primary: 'from-purple-400 to-purple-600',
    secondary: 'from-blue-400 to-blue-600',
    success: 'from-green-400 to-green-600',
    accent: 'from-pink-400 to-pink-600'
  };

  const handleAction = () => {
    if (route) {
      navigate(route);
    } else if (action) {
      action();
    }
  };

  return (
    <div className="bg-card rounded-2xl p-4 md:p-6 shadow-elevation-2 transition-smooth hover:shadow-elevation-3">
      <div className={`w-12 h-12 md:w-14 md:h-14 rounded-xl bg-gradient-to-br ${colorClasses?.[color]} flex items-center justify-center mb-3 md:mb-4`}>
        <Icon name={icon} size={24} color="#FFFFFF" />
      </div>
      <h3 className="text-lg md:text-xl font-semibold text-foreground mb-2">{title}</h3>
      <p className="text-sm md:text-base text-muted-foreground mb-4">{description}</p>
      <Button 
        variant="outline" 
        fullWidth 
        iconName="Plus" 
        iconPosition="left"
        onClick={handleAction}
      >
        {title}
      </Button>
    </div>
  );
};

export default QuickActionCard;